"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
(0, client_1.gql) `
  query GetAccelaConfiguration($accountId: ID!) {
    account(id: $accountId) {
      id
      thirdPartySystemConfigurations(type: accela) {
        ...AccelaConfiguration
      }
    }
  }

  mutation CreateAccelaConfiguration(
    $data: CreateThirdPartySystemConfigurationInput!
  ) {
    createThirdPartySystemConfiguration(data: $data) {
      ...AccelaConfiguration
    }
  }

  mutation UpdateAccelaConfiguration(
    $data: UpdateThirdPartySystemConfigurationInput!
  ) {
    updateThirdPartySystemConfiguration(data: $data) {
      ...AccelaConfiguration
    }
  }

  fragment AccelaConfiguration on ThirdPartySystemConfiguration {
    id
    name
    sourceConfiguration {
      type
      agencyName
      environment
      username
      scope
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjZWxhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vY29tcG9uZW50cy9TZXR0aW5ncy9EYXRhL0ludGVncmF0aW9ucy9fX3F1ZXJpZXNfXy9hY2NlbGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwyQ0FBcUM7QUFFckMsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FxQ0YsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdxbCB9IGZyb20gXCJAYXBvbGxvL2NsaWVudFwiO1xuXG5ncWxgXG4gIHF1ZXJ5IEdldEFjY2VsYUNvbmZpZ3VyYXRpb24oJGFjY291bnRJZDogSUQhKSB7XG4gICAgYWNjb3VudChpZDogJGFjY291bnRJZCkge1xuICAgICAgaWRcbiAgICAgIHRoaXJkUGFydHlTeXN0ZW1Db25maWd1cmF0aW9ucyh0eXBlOiBhY2NlbGEpIHtcbiAgICAgICAgLi4uQWNjZWxhQ29uZmlndXJhdGlvblxuICAgICAgfVxuICAgIH1cbiAgfVxuXG4gIG11dGF0aW9uIENyZWF0ZUFjY2VsYUNvbmZpZ3VyYXRpb24oXG4gICAgJGRhdGE6IENyZWF0ZVRoaXJkUGFydHlTeXN0ZW1Db25maWd1cmF0aW9uSW5wdXQhXG4gICkge1xuICAgIGNyZWF0ZVRoaXJkUGFydHlTeXN0ZW1Db25maWd1cmF0aW9uKGRhdGE6ICRkYXRhKSB7XG4gICAgICAuLi5BY2NlbGFDb25maWd1cmF0aW9uXG4gICAgfVxuICB9XG5cbiAgbXV0YXRpb24gVXBkYXRlQWNjZWxhQ29uZmlndXJhdGlvbihcbiAgICAkZGF0YTogVXBkYXRlVGhpcmRQYXJ0eVN5c3RlbUNvbmZpZ3VyYXRpb25JbnB1dCFcbiAgKSB7XG4gICAgdXBkYXRlVGhpcmRQYXJ0eVN5c3RlbUNvbmZpZ3VyYXRpb24oZGF0YTogJGRhdGEpIHtcbiAgICAgIC4uLkFjY2VsYUNvbmZpZ3VyYXRpb25cbiAgICB9XG4gIH1cblxuICBmcmFnbWVudCBBY2NlbGFDb25maWd1cmF0aW9uIG9uIFRoaXJkUGFydHlTeXN0ZW1Db25maWd1cmF0aW9uIHtcbiAgICBpZFxuICAgIG5hbWVcbiAgICBzb3VyY2VDb25maWd1cmF0aW9uIHtcbiAgICAgIHR5cGVcbiAgICAgIGFnZW5jeU5hbWVcbiAgICAgIGVudmlyb25tZW50XG4gICAgICB1c2VybmFtZVxuICAgICAgc2NvcGVcbiAgICB9XG4gIH1cbmA7XG4iXX0=